import { CLEAR_INVITABLES } from '../actions/groups'

const invitables = (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_INVITABLES:
      state = {}
      break
  }
  return state
}

export default invitables
